// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__9LCZN","text":"Tag_text__PFSsp","close":"Tag_close__UpSMQ","icon":"Tag_icon__62BcC"};